//Structure remains from sagas, adapt to graphql
import QuestionsContainer from '../components/QuestionsContainer'
export default QuestionsContainer